import React from 'react';
import moment from 'moment';
import {_GPY} from '../../../env.js'

class AnalogClock extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            timerIsActive : this.props.defaultData!==undefined&&this.props.defaultData[this.props.stateName+'_isactive']!==undefined?this.props.defaultData[this.props.stateName+'_isactive']:false,

            secondDegrees: 0,
            minuteDegress: 0,
            hourDegrees: 0,

            theme:"default",
            gmt : props.gmt!==undefined? parseInt( props.gmt ) : 0,
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = undefined;
    }



    onData (data,key) {
      if ( key !== undefined ) {
          if ( key === this.props.stateName ) {
              if( data.visible === true  || data.visible === "true" ) {

                var g = eval('(function () {return data!==undefined && data.'+this.props.element.dataSource+' !== undefined ? data.'+this.props.element.dataSource+':0;})').call(this);
                this.setState({gmt:g});

                this.tick();
                clearInterval(this.interval);
                this.interval = undefined;
                this.interval = setInterval(this.tick.bind(this), 1000);
              } else {
                clearInterval(this.interval);
                this.interval = undefined;
              }
          }
      }
    }


    componentDidMount() {
        console.log(this.props.stateName);
        this.props.display.registDataListener(this.props.stateName,this);
        if(this.props.readAlong !== undefined) {
          var readAlongs = this.props.readAlong.split("|");
          for (var r in readAlongs){
              this.props.display.registDataListener(readAlongs[r],this);
          }
        }

        if(this.props.display.state.gameStates[this.props.stateName]!==undefined) {
          this.onData(this.props.display.state.gameStates[this.props.stateName],this.props.stateName);
        }
      }


    tick() {    
        const now = moment.utc().utcOffset(this.state.gmt)
    //    console.log("GMT",this.state.gmt,now.hours());

        var hours = now.hours() % 12;
        if (hours === 0) {
          hours = 12;
        }
        var minutes =  (now.minutes()/60) * 360;
        this.setState({
        	secondDegrees: (now.seconds()/60) * 360,
        	minutesDegrees: minutes,
        	hourDegrees: ((hours/12 ) * 360) + (minutes/12),
        });
    }


  render() {
    const clockOverlay = this.props.element;
    var theme = clockOverlay!==undefined&&clockOverlay.displayRule!==undefined?clockOverlay.displayRule:"default";

    var left = ((this.props.element.height*47)/100);
    var top = ((this.props.element.height*10)/100);
    var height = ((this.props.element.height*38)/100);
    var hourScale = ((this.props.element.height*7)/100);
    var secondsScale = ((this.props.element.height*4)/100);
    var midScale = ((this.props.element.height*5)/100);
    var corner = ((this.props.element.height*5)/100);;
    var w1 = ((this.props.element.height*1)/100);
    var w2 = ((this.props.element.height*2)/100);
    var w3 = ((this.props.element.height*3)/100);
    //var w4 = ((this.props.element.height*4)/100);

    const midStyle = {
      width: midScale+"px", height: (midScale)+"px", top: ((height+top) - (midScale/2))+"px",left: (left+(w3/2)-(midScale/2))+"px", borderRadius: corner+"px", boxShadow: "0px 0px "+(w2)+"px rgba(0, 0, 0, 0.5)"
    };

    const secondStyle = {
     transform: `rotate(${this.state.secondDegrees}deg)`,
      width: w1+"px", height: (height+secondsScale)+"px", top: (top-secondsScale)+"px",left: (left + (w2/2)) +"px", borderRadius: corner+"px", boxShadow: "0px 0px "+(w1/2)+"px rgba(0, 0, 0, 0.5)"
    };
    const minuteStyle = {
        transform: `rotate(${this.state.minutesDegrees}deg)`,
        width: w2+"px", height: height+"px", top: top+"px",left: (left+ + (w1/2))+"px",borderRadius: corner+"px", boxShadow: "0px 0px "+w1+"px rgba(0, 0, 0, 0.5)"
    }
    const hourStyle = {
        transform: `rotate(${this.state.hourDegrees}deg)`,
        width: w3+"px", height: (height-hourScale)+"px", top: (top+hourScale)+"px" ,left: (left)+"px",borderRadius: corner+"px", boxShadow: "0px 0px "+(w3/2)+"px rgba(0, 0, 0, 0.5)"
    };

    var border = (this.props.element.height*2)/100;
    var clock = { width: this.props.element.height+"px",
                  height: this.props.element.height+"px",
                  borderWidth : border + "px",
                  borderRadius: (this.props.element.height + border) + "px",
                  backgroundImage: "url(" + (_GPY.resource("images/ziffernblatt_" + theme)) + ".png)",
                  backgroundSize: "contain"
                }

    return (<div className={"clock_"+this.state.theme} style={clock}>
              <div className={"hand hour-hand_"+theme} style={hourStyle}></div>
              <div className={"hand minute-hand_"+theme} style={minuteStyle}></div>
              <div className={"hand second-hand_"+theme} style={secondStyle}></div>
              <div className={"clock_mid_"+theme} style={midStyle}></div>
            </div>);
  }

}

export default AnalogClock;
